{
  "es": {
    "hangarPlanner": {
      "title": "Planificador de hangar",
      "lead": "Planifica el hangar que quieres en slots —los roles que quieres cubrir— y calcula cómo llegar desde el hangar que tienes: qué conservar, qué fundir (melt) y qué upgrades y buy-backs usar.",
      "createPlan": "Nuevo plan",
      "editPlan": "Editar plan",
      "destroyPlan": "Eliminar plan",
      "confirmDestroy": "¿Eliminar este plan? Tu hangar no se verá afectado.",
      "share": "Compartir por enlace",
      "copyShareLink": "Copiar enlace para compartir",
      "unshare": "Dejar de compartir",
      "shared": "Compartido",
      "sharedMissing": "Este plan no está compartido o el enlace ha cambiado.",
      "addToWishlist": "Añadir compras a la lista de deseos",
      "confirmAddToWishlist": "¿Añadir a tu lista de deseos todas las naves que este plan aún tiene que conseguir?",
      "compareWith": "Comparar con %{plan}",
      "compareTitle": "%{left} vs. %{right}",
      "slotsCount": {
        "one": "%{count} slot",
        "other": "%{count} slots"
      },
      "updatedAt": "Actualizado el %{date}",
      "empty": {
        "title": "Aún no hay planes",
        "text": "Empieza un plan desde cero, desde tu hangar, desde tu lista de deseos o copiando otro plan."
      },
      "noSlots": "Este plan aún no tiene slots. Añade un slot por cada rol que quieras que cubra tu hangar.",
      "placeholderRoles": {
        "starter": "Nave para el día a día",
        "cargo": "Carguero",
        "exploration": "Explorador"
      },
      "useAsFirstSlot": "Convertir en mi primer slot",
      "addSlot": "Añadir slot",
      "editSlot": "Editar slot",
      "editSlotOf": "Editar %{slot}",
      "slotSettings": "Nombre y filtros",
      "removeSlot": "Quitar slot",
      "confirmRemoveSlot": "¿Quitar este slot junto con sus naves y vías de obtención?",
      "openSlotHint": "Aún no has elegido ninguna nave. Añade una, o varias si estás indeciso.",
      "addShips": "Añadir naves",
      "addCandidates": "Naves para %{slot}",
      "addToSlot": "Añadir al slot",
      "inSlot": "En este slot",
      "choose": "Elegir",
      "chooseHint": "Elige la nave para la que planifica este slot. Las demás naves salen del slot junto con sus vías de obtención.",
      "removeCandidate": "Quitar nave",
      "ownedCount": {
        "one": "%{count} en tu hangar",
        "other": "%{count} en tu hangar"
      },
      "notOnSale": "no está a la venta",
      "routes": "Cómo conseguirlas",
      "editRoute": "Vía para %{ship}",
      "removeRoute": "Quitar vía",
      "unresolvedUnits": {
        "one": "%{count} nave aún no tiene vía",
        "other": "%{count} naves aún no tienen vía"
      },
      "routeMustEnd": "La vía tiene que terminar en la %{ship}.",
      "upgradeSteps": "Upgrades",
      "stepNumber": "Upgrade %{number}",
      "addStep": "Añadir upgrade",
      "removeStep": "Quitar upgrade",
      "sourceMissing": "ya no está en tu hangar",
      "melts": "Melts",
      "noMelts": "No hay naves que fundir.",
      "addMelt": "Fundir una nave",
      "editMelt": "Editar melt",
      "removeMelt": "Conservar la nave",
      "estimated": "estimación",
      "free": "Gratis",
      "unknownPrice": "Desconocido",
      "fields": {
        "name": "Nombre",
        "description": "Descripción",
        "startingCredit": "Crédito de tienda",
        "startingCreditInfo": "Crédito de tienda que ya tienes, en USD.",
        "source": "Empezar desde",
        "sourcePlan": "Plan a copiar",
        "slotLabel": "Rol",
        "slotLabelPlaceholder": "p. ej. Carguero principal",
        "quantity": "Naves",
        "startKind": "Empieza como",
        "ownedShip": "Nave de tu hangar",
        "buyback": "Pledge de buy-back",
        "priceOverride": "Precio pagado",
        "priceOverrideInfo": "Déjalo vacío para usar el precio actual de la tienda, o introduce un precio de oferta o de warbond.",
        "upgradeSource": "Upgrade desde",
        "ownedUpgrade": "Upgrade en tu hangar de RSI",
        "upgradeTo": "Upgrade a",
        "meltShip": "Nave a fundir",
        "meltValue": "Crédito",
        "meltValueInfo": "Lo que da fundirla. Déjalo vacío para usar el valor que RSI da al pledge, o el precio de hoy en la tienda si la sincronización del hangar no lo ha leído.",
        "slotDescription": "Descripción",
        "filters": "Naves que encajan",
        "filtersInfo": "El selector de naves se abre con estos filtros. Las naves que no encajan se pueden añadir igualmente y se marcan.",
        "priceFrom": "Precio desde",
        "priceTo": "Precio hasta",
        "minCargo": "Carga mínima",
        "onSaleOnly": "Solo naves a la venta",
        "buybackTokens": "Fichas de recompra",
        "buybackTokensInfo": "Cada ficha te permite pagar una recompra con crédito de tienda. Sin ella, una recompra cuesta dinero nuevo.",
        "buybackTokensSynced": "Cada ficha te permite pagar una recompra con crédito de tienda. Tu última sincronización de recompras leyó %{count} de RSI; déjalo vacío para usar ese valor.",
        "vatRate": "IVA",
        "vatRateInfo": "El IVA que RSI añade al pagar donde vives, p. ej. 21 en España. Solo se aplica al dinero nuevo; el crédito de tienda ya lo incluye."
      },
      "sources": {
        "empty": "Un plan vacío",
        "hangar": "Mi hangar",
        "wishlist": "Mi lista de deseos",
        "plan": "Otro plan"
      },
      "states": {
        "open": "Abierto",
        "decided": "Decidido",
        "undecided": "Indeciso"
      },
      "startKinds": {
        "owned": "Conservada del hangar",
        "store": "Compra en la tienda",
        "ingame": "Comprada en el juego",
        "buyback": "Buy-back"
      },
      "upgradeSources": {
        "store": "Tienda",
        "owned_ccu": "Mi hangar de RSI",
        "buyback": "Buy-back"
      },
      "vehicleStatuses": {
        "kept": "Conservada",
        "upgraded": "Mejorada",
        "unrouted": "Falta la ruta",
        "melted": "Fundida",
        "pending": "Por decidir",
        "change": "Debe cambiar",
        "unassigned": "Fuera del plan"
      },
      "changes": {
        "added": "Nueva",
        "removed": "Fuera",
        "more": "Más",
        "fewer": "Menos",
        "unchanged": "Igual"
      },
      "issues": {
        "missing_price": "%{name} no tiene un precio conocido, así que el total no la incluye.",
        "not_on_sale": "%{name} no está a la venta en este momento."
      },
      "summary": {
        "title": "Costes",
        "spend": "Gasto nuevo",
        "routedSpend": "Gasto con vía",
        "maxSpend": "Máximo posible",
        "upTo": "hasta %{value}",
        "meltCredit": "Crédito de los melts",
        "startingCredit": "Crédito de tienda",
        "net": "Coste neto",
        "cashNeeded": "Aún por pagar",
        "remainingCredit": "Crédito restante",
        "estimatedMelts": {
          "one": "%{count} estimado",
          "other": "%{count} estimados"
        },
        "openSlots": {
          "one": "%{count} slot sin nave",
          "other": "%{count} slots sin nave"
        },
        "undecidedSlots": {
          "one": "%{count} slot indeciso",
          "other": "%{count} slots indecisos"
        },
        "unresolved": {
          "one": "%{count} nave sin vía",
          "other": "%{count} naves sin vía"
        },
        "incomplete": "El total está incompleto",
        "complete": "Cada nave tiene una vía y un precio.",
        "buybackCash": "Recompras con dinero nuevo",
        "buybacksWithoutToken": {
          "one": "%{count} recompra sin ficha",
          "other": "%{count} recompras sin ficha"
        },
        "tokensShort": {
          "one": "%{count} recompra usa una ficha, pero tienes %{available}. El resto cuenta como dinero nuevo.",
          "other": "%{count} recompras usan una ficha, pero tienes %{available}. El resto cuenta como dinero nuevo."
        }
      },
      "comparison": {
        "title": "Comparado con tu hangar",
        "yourShips": "Tus naves",
        "noShips": "Tu hangar no tiene naves.",
        "changes": "Cambios",
        "noChanges": "Sin cambios.",
        "toAcquire": "Aún por conseguir",
        "hangar": "Hangar",
        "plan": "Plan",
        "happens": "Qué pasa",
        "meltCredit": "%{value} de crédito",
        "leaves": "Sale de tu hangar",
        "notOwned": "No está en tu hangar",
        "lead": "A la izquierda cada nave que tienes, a la derecha cada nave que necesita el plan, y en medio lo que pasa.",
        "anotherPlan": "Comparar con otro plan",
        "tallies": {
          "pending": {
            "one": "%{count} por decidir",
            "other": "%{count} por decidir"
          },
          "change": {
            "one": "%{count} debe cambiar",
            "other": "%{count} deben cambiar"
          },
          "kept": {
            "one": "%{count} conservada",
            "other": "%{count} conservadas"
          },
          "upgraded": {
            "one": "%{count} mejorada",
            "other": "%{count} mejoradas"
          },
          "unrouted": {
            "one": "%{count} sin ruta",
            "other": "%{count} sin ruta"
          },
          "melted": {
            "one": "%{count} fundida",
            "other": "%{count} fundidas"
          },
          "toAcquire": {
            "one": "%{count} aún por conseguir",
            "other": "%{count} aún por conseguir"
          },
          "open": {
            "one": "%{count} hueco abierto",
            "other": "%{count} huecos abiertos"
          }
        },
        "costsTitle": "Lo que cuesta",
        "flow": {
          "steps": {
            "one": "%{count} mejora · %{price}",
            "other": "%{count} mejoras · %{price}"
          },
          "shipOf": "nave %{number} de %{count}",
          "noRoute": "Aún sin vía",
          "planRoute": "Planificar ruta",
          "noUpgrade": "No hay mejora posible",
          "pickOtherStart": "elige otro inicio",
          "notCounted": "no está en el total",
          "onlyInMax": "solo en el máximo",
          "noShip": "aún sin nave",
          "folded": {
            "kept": {
              "one": "%{count} conservada tal cual",
              "other": "%{count} conservadas tal cual"
            },
            "melted": {
              "one": "%{count} fundida",
              "other": "%{count} fundidas"
            },
            "unassigned": {
              "one": "%{count} nave fuera del plan",
              "other": "%{count} naves fuera del plan"
            }
          }
        },
        "changeSides": {
          "in": "Entra",
          "out": "Sale"
        },
        "unchangedCount": {
          "one": "%{count} modelo se queda igual.",
          "other": "%{count} modelos se quedan igual."
        },
        "after": "Tras el plan"
      },
      "metrics": {
        "title": "Estadísticas",
        "total": "Naves",
        "uniqueModelsCount": "Modelos distintos",
        "manufacturerCount": "Fabricantes",
        "flightReadyCount": "Listas para volar",
        "totalCrew": "Tripulación",
        "totalCargo": "Carga (SCU)",
        "totalPledgeValue": "Valor en tienda",
        "largestShip": "Nave más grande",
        "smallestShip": "Nave más pequeña",
        "classifications": "Clasificaciones",
        "sizes": "Tamaños",
        "productionStatuses": "Estado de producción"
      },
      "drift": {
        "title": "Tu hangar ha cambiado desde que se hizo este plan",
        "missing": {
          "one": "%{count} nave o pledge que usa el plan ya no está.",
          "other": "%{count} naves o pledges que usa el plan ya no están."
        },
        "changed": {
          "one": "%{count} nave es ahora otro modelo.",
          "other": "%{count} naves son ahora otros modelos."
        },
        "added": "Nuevo en tu hangar: %{ships}",
        "prices": "Los precios han cambiado: %{before} al planificar, %{now} hoy.",
        "rebase": "Actualizar desde el hangar"
      },
      "messages": {
        "saved": "Plan guardado.",
        "saveFailed": "No ha funcionado. Revisa los datos introducidos.",
        "shareCopied": "Enlace para compartir copiado.",
        "unshared": "El enlace para compartir ya no funciona.",
        "addedToWishlist": {
          "one": "%{count} nave añadida a tu lista de deseos.",
          "other": "%{count} naves añadidas a tu lista de deseos."
        },
        "rebased": "Plan actualizado desde tu hangar.",
        "sharingOn": "Compartir está activado. Cualquiera con el enlace puede ver este plan.",
        "copyFailed": "No se pudo copiar el enlace. Cópialo desde el campo.",
        "filtersSaved": "Filtros guardados para %{slot}"
      },
      "filterChips": {
        "priceFrom": "desde %{price}",
        "priceTo": "hasta %{price}",
        "cargo": "%{cargo} SCU o más",
        "onSale": "a la venta"
      },
      "outsideFilters": "fuera de los filtros de este slot",
      "shareLink": "Enlace para compartir",
      "specs": {
        "price": "Precio",
        "cargo": "Carga",
        "crew": "Tripulación",
        "size": "Tamaño",
        "best": "mejor"
      },
      "readiness": {
        "routed": {
          "one": "%{routed} de %{count} nave tiene vía",
          "other": "%{routed} de %{count} naves tienen vía"
        },
        "undecided": "%{slot} está indeciso",
        "open": "%{slot} no tiene nave",
        "unresolved": {
          "one": "%{slot}: %{count} nave sin vía",
          "other": "%{slot}: %{count} naves sin vía"
        }
      },
      "meta": {
        "undecided": "%{count} indecisos",
        "open": "%{count} abiertos"
      },
      "route": {
        "stillToReach": "Aún por alcanzar",
        "yourRoute": "Tu vía",
        "done": "La vía termina en la %{ship}.",
        "isTarget": "Misma nave",
        "search": "Buscar",
        "noMatch": "Nada coincide.",
        "reaches": "Llega a la %{ship}",
        "left": {
          "one": "queda %{count}",
          "other": "quedan %{count}"
        },
        "showAll": {
          "one": "Mostrar tu %{count} mejora",
          "other": "Mostrar las %{count} mejoras"
        },
        "showFitting": "Mostrar solo las mejoras que encajan",
        "unknownTarget": "A qué nave mejora",
        "startCost": "Inicio",
        "sort": {
          "price": "Precio",
          "name": "Nombre"
        },
        "change": "Cambiar",
        "from": "Desde",
        "to": "Hasta",
        "todaysPrice": "Precio de hoy: %{price}",
        "noStoreShip": "Ninguna nave de la tienda encaja aquí.",
        "paidWithCredit": "Crédito de tienda",
        "paidWithCash": "Dinero nuevo",
        "vat": "IVA (%{rate} %)",
        "cashWithVat": "Dinero nuevo con IVA",
        "paymentHint": "El crédito de tienda cubre la tienda y las recompras con ficha. Una recompra sin ficha cuesta dinero nuevo, igual que lo que tu crédito no cubra.",
        "ownedPaid": "Ya pagada",
        "noHeld": {
          "owned_ccu": "Ninguna de las mejoras de tu hangar de RSI parte de la %{ship}.",
          "buyback": "Ninguna de tus mejoras de recompra parte de la %{ship}."
        },
        "shipCard": "Nave",
        "useToken": "Usar ficha de recompra",
        "withToken": "pagada con ficha"
      },
      "meltList": {
        "none": "Según RSI, ninguna de tus naves se puede fundir. Quita el filtro para elegir cualquier nave.",
        "credit": "%{value} de crédito",
        "estimate": "%{value} estimado",
        "wholePledge": {
          "one": "funde %{count} objeto",
          "other": "funde todo el pledge: %{count} objetos"
        },
        "meltableOnly": "Solo fundibles",
        "notMeltable": "no fundible",
        "notSynced": "sin sincronizar",
        "noShips": "Ninguna de tus naves está libre para fundir.",
        "inPackage": "en %{name}",
        "contents": "Se funde con ella",
        "contentsOf": "Se funde con ella, como parte de %{name}",
        "unlisted": {
          "one": "%{count} objeto más que la sincronización del hangar no recoge",
          "other": "%{count} objetos más que la sincronización del hangar no recoge"
        }
      },
      "decisions": {
        "keep": "Conservar tal cual",
        "melt": "Fundir",
        "change": "Marcar como debe cambiar",
        "pending": "Volver a por decidir",
        "upgradeTo": "Mejorar %{name} a",
        "keepPending": "Conservar todas las pendientes"
      },
      "pick": {
        "pickStart": "Elegir un inicio",
        "pickEnd": "Elegir en qué termina",
        "startOf": "Elegir el inicio para %{ship}",
        "endOf": "Elegir en qué termina %{ship}",
        "startTitle": "Inicio para %{ship}",
        "startEyebrow": "Nave de inicio",
        "endTitle": "En qué termina %{ship}",
        "endEyebrow": "Nave final",
        "buyNew": "Comprar nueva en la tienda",
        "current": "Inicio actual",
        "use": "Usar",
        "noShips": "Ninguna nave del hangar está libre para este hueco.",
        "removeStart": "Quitar del hueco",
        "same": "La misma nave, tal como está",
        "sameModel": "Mismo modelo",
        "noEnds": "Ninguna nave en la que pueda convertirse esta.",
        "removeEnd": "Sacar del plan",
        "anyShip": "Cualquier nave",
        "buyChosen": "La nave que elijas a continuación",
        "onlyMelt": "No existen mejoras para ella, solo se puede fundir",
        "excludes": "Descarta %{ships}",
        "ccuSalesOnly": "CCU solo en rebajas",
        "ccuUnknown": "Aún no se ha visto ningún CCU",
        "sources": {
          "hangar": "Tu hangar",
          "buyback": "Buy-back",
          "store": "Tienda"
        },
        "filters": "Acotar los inicios",
        "saveFilters": "Guardar filtros para este hueco",
        "chooseShip": "Elige una nave",
        "earnInGame": "Ganar en el juego",
        "newSlot": "Hueco nuevo",
        "endSources": {
          "plan": "Huecos del plan",
          "catalogue": "Cualquier nave"
        }
      },
      "slotsTitle": "Slots",
      "editSlots": "Editar slots",
      "slotNumber": "Hueco %{number}",
      "suggestions": {
        "title": "Sugerencias",
        "lead": "Ideas para el hangar con el que termina este plan, sin las naves que funde o mejora.",
        "redundant": "Naves redundantes",
        "noRedundant": "Ninguna nave hace el mismo trabajo dos veces.",
        "duplicate": "%{ship} × %{count}",
        "hints": {
          "duplicate": "La misma nave más de una vez. Fundir una de sobra devuelve crédito de tienda.",
          "role": "%{count} naves del mismo rol. Quizá baste con una."
        },
        "inSlot": "Hueco %{slot}",
        "inHangar": "Tu hangar"
      }
    }
  }
}
